
// Reusable animation variants for framer-motion
export const fadeIn = (delay = 0, y = 20) => ({
  hidden: { opacity: 0, y: y, scale: 0.98 },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1, 
    transition: { 
      duration: 0.7, 
      delay, 
      ease: [0.6, -0.05, 0.01, 0.99] 
    } 
  },
});

export const slideIn = (direction = 'up', delay = 0) => {
  const directions = {
    up: { y: 30 },
    down: { y: -30 },
    left: { x: 30 },
    right: { x: -30 }
  };

  return {
    hidden: { 
      opacity: 0, 
      ...directions[direction],
      scale: 0.98 
    },
    visible: { 
      opacity: 1, 
      x: 0, 
      y: 0, 
      scale: 1, 
      transition: { 
        duration: 0.6, 
        delay, 
        ease: [0.6, -0.05, 0.01, 0.99] 
      } 
    },
  };
};

export const staggerContainer = (staggerChildren = 0.1) => ({
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren,
      delayChildren: 0.1
    }
  }
});

export const scaleIn = (delay = 0) => ({
  hidden: { 
    opacity: 0, 
    scale: 0.8 
  },
  visible: { 
    opacity: 1, 
    scale: 1, 
    transition: { 
      duration: 0.5, 
      delay,
      ease: [0.6, -0.05, 0.01, 0.99] 
    } 
  },
});
